/*
 * @Author: Tahiti
 * @Date: 2025-10-20 15:27:20
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-10-28 13:45:45
 * @Description: 首页 SEO 配置（与 seo.ts 的 home 配置保持一致）
 * @FilePath: /weryai-web/locales/modules/useHead.ts
 */
export default {
    zh: {
        title: '微鲤AI：一站式 AI 视频和图像创作平台',
        description:
            '使用 微鲤AI，免费、一站式、一体化的 AI 图像和视频生成器，通过文本提示、图像或视频创建图像/视频。将您的想法转化为高分辨率和高质量的图像和视频。',
        keywords:
            'AI视频生成器, AI图像生成器, 文本转视频, 图像转视频, AI视频创作, AI图像创作, 视频生成, 图像生成, AI内容创作, 微鲤AI',
    },
    en: {
        title: '微鲤AI: The Ultimate AI Video & Image Creation Platform',
        description:
            'Use 微鲤AI, the free, ultimate, all-in-one AI image & video generator, to create images/videos with text prompts, images or videos. Turn your ideas to images and videos with high resolution and quality.',
        keywords:
            'AI video generator, AI image generator, text to video, image to video, AI video creation, AI image creation, video generation, image generation, AI content creation, 微鲤AI',
    },
    ja: {
        title: '微鲤AI：究極のAI動画・画像作成プラットフォーム',
        description:
            'WeryAIを使用して、無料で究極のオールインワンAI画像・動画ジェネレーターで、テキストプロンプト、画像、または動画から画像/動画を作成します。高解像度・高品質の画像と動画にアイデアを変換します。',
        keywords:
            'AI動画ジェネレーター, AI画像ジェネレーター, テキストから動画, 画像から動画, AI動画作成, AI画像作成, 動画生成, 画像生成, AIコンテンツ作成, 微鲤AI',
    },
    ko: {
        title: '微鲤AI: 궁극의 AI 비디오 및 이미지 제작 플랫폼',
        description:
            'WeryAI를 사용하여 무료 궁극의 올인원 AI 이미지 및 비디오 생성기로 텍스트 프롬프트, 이미지 또는 비디오에서 이미지/비디오를 만듭니다. 고해상도 및 고품질의 이미지와 비디오로 아이디어를 변환합니다.',
        keywords:
            'AI 비디오 생성기, AI 이미지 생성기, 텍스트를 비디오로, 이미지를 비디오로, AI 비디오 제작, AI 이미지 제작, 비디오 생성, 이미지 생성, AI 콘텐츠 제작, 微鲤AI',
    },
    tw: {
        title: '微鲤AI：一站式 AI 影片與圖像創作平台',
        description:
            '使用 微鲤AI，免費、一站式的一體化 AI 圖像與影片生成器，透過文字提示、圖片或影片建立影像/影片，將想法轉化為高解析與高品質的作品。',
        keywords:
            'AI 影片生成器, AI 圖像生成器, 文生影片, 圖生影片, AI 影片創作, AI 圖像創作, 影片生成, 圖片生成, AI 內容創作, 微鲤AI',
    },
    pl: {
        title: '微鲤AI: najlepsza platforma do tworzenia wideo i obrazów AI',
        description:
            'Korzystaj z 微鲤AI — darmowego, kompleksowego generatora obrazów i wideo AI — aby tworzyć treści na podstawie promptów, obrazów lub wideo. Zamieniaj pomysły w materiały o wysokiej jakości i rozdzielczości.',
        keywords:
            'generator wideo AI, generator obrazów AI, tekst na wideo, obraz na wideo, tworzenie wideo AI, tworzenie obrazów AI, generowanie wideo, generowanie obrazów, tworzenie treści AI, 微鲤AI',
    },
    es: {
        title: '微鲤AI: La Plataforma Definitiva de Creación de Videos e Imágenes con IA',
        description:
            'Usa 微鲤AI, el generador de imágenes y videos con IA gratuito, definitivo y todo en uno, para crear imágenes/videos con indicaciones de texto, imágenes o videos. Convierte tus ideas en imágenes y videos de alta resolución y calidad.',
        keywords:
            'generador de videos con IA, generador de imágenes con IA, texto a video, imagen a video, creación de videos con IA, creación de imágenes con IA, generación de videos, generación de imágenes, creación de contenido con IA, 微鲤AI',
    },
    fr: {
        title: '微鲤AI : La Plateforme Ultime de Création de Vidéos et Images IA',
        description:
            'Utilisez 微鲤AI, le générateur d\'images et vidéos IA gratuit, ultime et tout-en-un, pour créer des images/vidéos avec des invites texte, images ou vidéos. Transformez vos idées en images et vidéos haute résolution et qualité.',
        keywords:
            'générateur vidéo IA, générateur image IA, texte vers vidéo, image vers vidéo, création vidéo IA, création image IA, génération vidéo, génération image, création contenu IA, 微鲤AI',
    },
    de: {
        title: '微鲤AI: Die Ultimative KI-Video- und Bildererstellungsplattform',
        description:
            'Verwenden Sie 微鲤AI, den kostenlosen, ultimativen All-in-One-KI-Bild- und Videogenerator, um Bilder/Videos mit Textaufforderungen, Bildern oder Videos zu erstellen. Verwandeln Sie Ihre Ideen in hochauflösende und qualitativ hochwertige Bilder und Videos.',
        keywords:
            'KI-Videogenerator, KI-Bildgenerator, Text zu Video, Bild zu Video, KI-Videoerstellung, KI-Bilderstellung, Videogenerierung, Bildgenerierung, KI-Content-Erstellung, 微鲤AI',
    },
    ru: {
        title: '微鲤AI: Совершенная Платформа для Создания Видео и Изображений с ИИ',
        description:
            'Используйте 微鲤AI, бесплатный, совершенный, универсальный генератор изображений и видео с ИИ, для создания изображений/видео с текстовыми подсказками, изображениями или видео. Превратите свои идеи в изображения и видео высокого разрешения и качества.',
        keywords:
            'генератор видео с ИИ, генератор изображений с ИИ, текст в видео, изображение в видео, создание видео с ИИ, создание изображений с ИИ, генерация видео, генерация изображений, создание контента с ИИ, 微鲤AI',
    },
    pt: {
        title: '微鲤AI: A Plataforma Definitiva de Criação de Vídeos e Imagens com IA',
        description:
            'Use 微鲤AI, o gerador de imagens e vídeos com IA gratuito, definitivo e tudo-em-um, para criar imagens/vídeos com comandos de texto, imagens ou vídeos. Transforme suas ideias em imagens e vídeos de alta resolução e qualidade.',
        keywords:
            'gerador de vídeos com IA, gerador de imagens com IA, texto para vídeo, imagem para vídeo, criação de vídeos com IA, criação de imagens com IA, geração de vídeos, geração de imagens, criação de conteúdo com IA, 微鲤AI',
    },
    it: {
        title: '微鲤AI: La Piattaforma Definitiva per la Creazione di Video e Immagini con IA',
        description:
            'Usa 微鲤AI, il generatore di immagini e video con IA gratuito, definitivo e tutto-in-uno, per creare immagini/video con prompt di testo, immagini o video. Trasforma le tue idee in immagini e video ad alta risoluzione e qualità.',
        keywords:
            'generatore video IA, generatore immagini IA, testo a video, immagine a video, creazione video IA, creazione immagini IA, generazione video, generazione immagini, creazione contenuti IA, 微鲤AI',
    },
    ar: {
        title: '微鲤AI: منصة إنشاء الفيديو والصور بالذكاء الاصطناعي النهائية',
        description:
            'استخدم 微鲤AI، مولد الصور والفيديو بالذكاء الاصطناعي المجاني والنهائي والشامل، لإنشاء صور/فيديوهات بمطالبات نصية أو صور أو فيديوهات. حول أفكارك إلى صور وفيديوهات عالية الدقة والجودة.',
        keywords:
            'مولد فيديو بالذكاء الاصطناعي, مولد صور بالذكاء الاصطناعي, نص إلى فيديو, صورة إلى فيديو, إنشاء فيديو بالذكاء الاصطناعي, إنشاء صور بالذكاء الاصطناعي, توليد فيديو, توليد صور, إنشاء محتوى بالذكاء الاصطناعي, 微鲤AI',
        },
    th: {
        title: '微鲤AI: แพลตฟอร์มสร้างวิดีโอและภาพด้วย AI แบบครบวงจร',
        description:
            'ใช้ 微鲤AI เครื่องมือสร้างภาพและวิดีโอด้วย AI ฟรีแบบครบวงจร เพื่อสร้างภาพ/วิดีโอด้วยพรอมต์ข้อความ รูปภาพ หรือวิดีโอ เปลี่ยนไอเดียของคุณให้เป็นภาพและวิดีโอความละเอียดและคุณภาพสูง',
        keywords:
            'เครื่องมือสร้างวิดีโอด้วย AI, เครื่องมือสร้างภาพด้วย AI, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, การสร้างวิดีโอด้วย AI, การสร้างภาพด้วย AI, การสร้างวิดีโอ, การสร้างภาพ, การสร้างคอนเทนต์ด้วย AI, 微鲤AI',
        },
    da: {
        title: '微鲤AI: Den ultimative platform til AI-video- og billedskabelse',
        description:
            'Brug 微鲤AI, den gratis og ultimative alt-i-en AI-billed- og videogenerator, til at skabe billeder/videoer med tekstprompter, billeder eller videoer. Forvandl dine idéer til billeder og videoer i høj opløsning og kvalitet.',
        keywords:
            'AI-videogenerator, AI-billedgenerator, tekst til video, billede til video, AI-videoskabelse, AI-billedskabelse, videogenerering, billedgenerering, AI-indholdsskabelse, 微鲤AI',
        },
    no: {
        title: '微鲤AI: Den ultimate plattformen for AI-video- og bildeproduksjon',
        description:
            'Bruk 微鲤AI, den gratis, ultimate alt-i-ett AI bilde- og videogeneratoren, til å lage bilder/videoer med tekstprompter, bilder eller videoer. Gjør ideene dine om til bilder og videoer i høy oppløsning og kvalitet.',
        keywords:
            'AI-videogenerator, AI-bildegenerator, tekst til video, bilde til video, AI-videoproduksjon, AI-bildeproduksjon, videogenerering, bildegenerering, AI-innholdsproduksjon, 微鲤AI',
        },
    nl: {
        title: '微鲤AI: Het ultieme platform voor AI-video- en beeldcreatie',
        description:
            "Gebruik 微鲤AI, de gratis, ultieme alles-in-één AI-beeld- en videogenerator, om afbeeldingen/video\'s te maken met tekstprompts, afbeeldingen of video\'s. Zet je ideeën om in beelden en video\'s van hoge resolutie en kwaliteit.",
        keywords:
            'AI-videogenerator, AI-beeldgenerator, tekst naar video, beeld naar video, AI-videocreatie, AI-beeldcreatie, videogeneratie, beeldgeneratie, AI-contentcreatie, 微鲤AI',
        },
    id: {
        title: '微鲤AI: Platform Terbaik untuk Pembuatan Video & Gambar AI',
        description:
            'Gunakan 微鲤AI, generator gambar & video AI gratis yang serba ada, untuk membuat gambar/video dengan prompt teks, gambar, atau video. Ubah ide Anda menjadi gambar dan video berkualitas serta beresolusi tinggi.',
        keywords:
            'generator video AI, generator gambar AI, teks ke video, gambar ke video, pembuatan video AI, pembuatan gambar AI, generasi video, generasi gambar, pembuatan konten AI, 微鲤AI',
        },
    tr: {
        title: '微鲤AI: Yapay Zeka Video ve Görsel Üretimi için Nihai Platform',
        description:
            'Ücretsiz, nihai, hepsi bir arada yapay zeka görsel ve video üreticisi olan 微鲤AI\'yi kullanarak metin istemleri, görseller veya videolarla görsel/video oluşturun. Fikirlerinizi yüksek çözünürlüklü ve kaliteli görsel ve videolara dönüştürün.',
        keywords:
            'yapay zeka video üreticisi, yapay zeka görsel üreticisi, metinden video, görselden video, yapay zeka video üretimi, yapay zeka görsel üretimi, video üretimi, görsel üretimi, yapay zeka içerik üretimi, 微鲤AI',
    },
}
